import React, { useEffect, useState } from "react";
import styles from "../../css/SmsDownloadReport.module.css";
import { Box } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Loader from "../Loader/Loader";
import MasterTable from "../common/MasterTable";

const DownloadReport = ({
  handleCloseReportDown,
  callApi,
  data,
  pageDowRepDetails,
  noData,
  loading,
  header,
  headerToKey,
  entityType,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const DownloadHeaders = [
    "Request ID",
    "Req Date & Time",
    "From Date",
    "To Date",
    "Status",
    "File",
  ];

  const DownloadHeaderToKeyMap = {
    "Request ID": "id",
    "Req Date & Time": "createdDate",
    "From Date": "reqFromDate",
    "To Date": "reqToDate",
    Status: "status",
    File: "downloadUrl",
  };

  useEffect(() => {
    callApi(1);
  }, []);

  const pageSizeCount = pageDowRepDetails?.pageSize || 0;
  const totalRecord = pageDowRepDetails?.totalRecords || 0;
  const Header = header ? header : DownloadHeaders
  const HeaderToKeyMap = headerToKey ? headerToKey : DownloadHeaderToKeyMap

  return (
    <Box component="form">
      <div className={styles.modalOverlay}>
        <div className={styles.modalBox}>
          {/* Header */}
          <div className={styles.modalHeader}>
            <h2 className={styles.modalTitle}>Download Report</h2>
            <button
              onClick={handleCloseReportDown}
              className={styles.closeButton}
            >
              <HighlightOffIcon />
            </button>
          </div>

          {/* Content */}
          <div className={styles.DownModalContent}>
            {loading ? (
              <Loader />
            ) : (
              <MasterTable
                headers={Header}
                data={data}
                filterFields={["id"]}
                entityType="Download Report"
                entityType={entityType ? entityType : "Download Report"}
                headerToKeyMap={HeaderToKeyMap}
                loading={loading}
                pageDetails={pageDowRepDetails}
                noData={noData}
                currentPage={currentPage}
                pageSize={pageSizeCount}
                totalRecord={totalRecord}
                fetchNextData={(page) => callApi(page)}
                setCurrentPage={setCurrentPage}
                hideAction="hideAction"
              />
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default DownloadReport;
